import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Switch, Route } from 'react-router';
import { useLocation } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';
import { Normalize } from 'styled-normalize';
import { Helmet } from 'react-helmet';
import queryString from 'query-string';
import routes from 'root/routes';
import Header from 'components/Header';
import Footer from 'components/Footer';

import pendingData from 'store/pending/actions';
import { piwikMethod, trackGoogleAnalyticsPageView } from 'utils';
import { saveCampaignParams } from '@minerva-analytics/pantheon';

import { ABTestingContext } from '../../contexts';
import * as referralActions from '../../store/referral/actions';
import theme from '../../theme';
import logo from '../../assets/logo2_blue.png';

import { AppContainer, Content } from './App.styles';
import GlobalStyles from '../../index.styles';

const EventRoute = (props) => {
  useEffect(() => {
    piwikMethod(`setDocumentTitle`, [document.title]);
    piwikMethod(`setCustomUrl`, [props.location.pathname + props.location.search]);
    piwikMethod(`trackPageView`, []);
    trackGoogleAnalyticsPageView();
  }, [props.location]);

  return <Route {...props} />;
};

const PENDING_KEY = `signup`;

const App = () => {
  const { search, hash } = useLocation();
  const ABTests = [];
  const dispatch = useDispatch();

  useEffect(() => {
    const parsed = queryString.parse(search);

    saveCampaignParams(parsed);

    const autoPopSign = parsed.default_sign;

    if (autoPopSign) {
      dispatch(pendingData.updatePendingData({
        id: PENDING_KEY,
        changes: { sign: autoPopSign },
      }));
    }
  }, []);

  useEffect(() => {
    if (hash.includes(`#ref=`)) {
      const referralId = Number(hash.match(/\d+/)[0]);
      dispatch(referralActions.getReferralId(referralId));
    }
  }, [hash]);

  return (
    <ThemeProvider theme={theme}>
      <AppContainer>
        <Normalize />
        <GlobalStyles />
        <Header />
        <Helmet>
          <title>{ `Get Free Daily Horoscopes with Starguide` }</title>
          <meta name="og:title" property="og:title" content={ `Get Free Daily Horoscopes with Starguide` } />
          <meta name="og:description" property="og:description" content={`Curious about your future? Get your FREE life and love horoscope delivered straight to your inbox every day with Starguide!`} />
          <meta name="description" property="description" content={`Curious about your future? Get your FREE life and love horoscope delivered straight to your inbox every day with Starguide!`} />
          <meta name="og:image" property="og:image" content={logo} />
          <meta name="twitter:card" property="twitter:card" content="https://d65ygtp8rpx5n.cloudfront.net/logo_blue_2.png" />
          <html lang="en" />
          <link rel="apple-touch-icon" href="https://d65ygtp8rpx5n.cloudfront.net/apple_touch_iphone_2.png" />
          <link rel="apple-touch-icon" sizes="72x72" href="https://d65ygtp8rpx5n.cloudfront.net/apple_touch_ipad_2.png" />
          <link rel="apple-touch-icon" sizes="114x114" href="https://d65ygtp8rpx5n.cloudfront.net/apple_touch_iphone4_2.png" />
          <link rel="apple-touch-icon" sizes="144x144" href="https://d65ygtp8rpx5n.cloudfront.net/apple_touch_ipad_retina_2.png" />
        </Helmet>
        <ABTestingContext.Provider value={ABTests}>
          <Content>
            <Switch>
              {routes.map((route) => (
                <EventRoute key={ route.path } { ...route } />
              ))}
            </Switch>
          </Content>
        </ABTestingContext.Provider>
        <Footer />
      </AppContainer>
    </ThemeProvider>
  );
};

export default App;
